export const GET_CUSTOMER_LIST = "GET_CUSTOMER_LIST";
export const GET_CUSTOMER_LIST_NOT_IN_GROUP = "GET_CUSTOMER_LIST_NOT_IN_GROUP";
export const GET_A_CUSTOMER = "GET_A_CUSTOMER";
export const CHANGE_CUSTOMER_STATUS = "CHANGE_CUSTOMER_STATUS";
export const GET_CHART_INFO = "GET_CHART_INFO";
export const GET_CUSTOMER_HISTORY = "GET_CUSTOMER_HISTORY";
export const UPDATE_A_CUSTOMER = "UPDATE_A_CUSTOMER";
export const GET_TEMP_CUSTOMER = "GET_TEMP_CUSTOMER";
export const DELETE_A_CUSTOMER = "DELETE_A_CUSTOMER";
export const BULK_DELETE_CUSTOMERS = "BULK_DELETE_CUSTOMERS";
export const GET_GROUP_LIST = "GET_GROUP_LIST";
export const UPDATE_A_GROUP= "UPDATE_A_GROUP";
export const CREATE_A_GROUP= "CREATE_A_GROUP";
export const DELETE_A_GROUP= "DELETE_A_GROUP";
export const GET_A_GROUP_DETAIL = "GET_A_GROUP_DETAIL";
export const SEARCH_CUSTOMER = "SEARCH_CUSTOMER";
export const GET_A_DELETE_GROUP_DETAIL = "GET_A_DELETE_GROUP_DETAIL";
export const UPDATE_CUSTOMER_GROUP = "UPDATE_CUSTOMER_GROUP";
export const UPDATE_CUSTOMER_GROUP_STATUS = "UPDATE_CUSTOMER_GROUP_STATUS";
export const GET_CUSTOMER_CALLING_INFO = "GET_CUSTOMER_CALLING_INFO";
export const GET_SMS_TEMPLATE = "GET_SMS_TEMPLATE";
export const SEND_SMS = "SEND_SMS";
export const EDIT_SMS = "EDIT_SMS";
export const CREATE_CUSTOMER = "CREATE_CUSTOMER";

export const EXPORT_MEMBER = "EXPORT_MEMBER";
